import { render } from "./SortableHeader.vue?vue&type=template&id=086f5c41&scoped=true"
import script from "./SortableHeader.vue?vue&type=script&lang=js"
export * from "./SortableHeader.vue?vue&type=script&lang=js"

import "./SortableHeader.vue?vue&type=style&index=0&id=086f5c41&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-086f5c41"]])

export default __exports__